import React from "react";
import styles from "./styles.module.css";

export const FullHeight = ({ children }: { children?: React.ReactNode }) => (
  <div className={styles.component}>{children}</div>
);
